import styled, { css } from 'styled-components';

export const ErrorStateContainerStyled = styled.div<{ $fullScreen: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  background: var(--kaseya-background-secondary, #f7f8fa);

  ${({ $fullScreen }) =>
    $fullScreen
      ? css`
          min-height: 100vh;
        `
      : css`
          min-height: 100%;
        `}
`;

export const ErrorIconStyled = styled.img`
  width: 212px;
  max-width: 100%;
  margin-bottom: 32px;
`;

export const TitleStyled = styled.h1`
  margin: 0 0 16px;
  color: var(--kaseya-text-primary);
  font-family: var(--kaseya-main-font-family);
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
`;

export const DescriptionStyled = styled.p`
  margin: 0;
  color: var(--kaseya-text-secondary);
  font-family: var(--kaseya-main-font-family);
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
`;

export const RetryButtonWrapperStyled = styled.div`
  margin-top: 32px;
`;
